import {
  CONSUL_ADD_FAIL,
  CONSUL_ADD_REQUEST,
  CONSUL_ADD_RESET,
  CONSUL_ADD_SUCCESS,
  CONSUL_DELETE_FAIL,
  CONSUL_DELETE_REQUEST,
  CONSUL_DELETE_SUCCESS,
  CONSUL_DETAILS_FAIL,
  CONSUL_DETAILS_REQUEST,
  CONSUL_DETAILS_SUCCESS,
  CONSUL_LIST_FAIL,
  CONSUL_LIST_REQUEST,
  CONSUL_LIST_SUCCESS,
  CONSUL_UPDATE_FAIL,
  CONSUL_UPDATE_REQUEST,
  CONSUL_UPDATE_RESET,
  CONSUL_UPDATE_SUCCESS,
} from "../constants/honararyConsulConstant";

export const listConsulsReducer = (state = {}, action) => {
  switch (action.type) {
    case CONSUL_LIST_REQUEST:
      return {
        loading: true,
      };
    case CONSUL_LIST_SUCCESS:
      return {
        loading: false,
        success: true,
        consuls: action.payload,
      };

    case CONSUL_LIST_FAIL:
      return {
        loading: true,
        success: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export const listConsulReducer = (state = {}, action) => {
  switch (action.type) {
    case CONSUL_DETAILS_REQUEST:
      return {
        loading: true,
      };
    case CONSUL_DETAILS_SUCCESS:
      return {
        loading: false,
        success: true,
        consul: action.payload,
      };

    case CONSUL_DETAILS_FAIL:
      return {
        loading: true,
        success: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export const consulAddReducer = (state = {}, action) => {
  switch (action.type) {
    case CONSUL_ADD_REQUEST:
      return {
        loading: true,
      };
    case CONSUL_ADD_SUCCESS:
      return {
        loading: false,
        success: true,
      };
    case CONSUL_ADD_FAIL:
      return {
        loading: true,
        error: action.payload,
      };
    case CONSUL_ADD_RESET:
      return {
        loading: true,
        success: false,
      };
    default:
      return state;
  }
};
export const consulEditReducer = (state = {}, action) => {
  switch (action.type) {
    case CONSUL_UPDATE_REQUEST:
      return {
        loading: true,
      };
    case CONSUL_UPDATE_SUCCESS:
      return {
        loading: false,
        success: true,
      };
    case CONSUL_UPDATE_FAIL:
      return {
        loading: true,
        error: action.payload,
      };
    case CONSUL_UPDATE_RESET:
      return {
        loading: true,
        success: false,
      };
    default:
      return state;
  }
};
export const consulDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case CONSUL_DELETE_REQUEST:
      return {
        loading: true,
      };
    case CONSUL_DELETE_SUCCESS:
      return {
        loading: false,
        success: true,
      };
    case CONSUL_DELETE_FAIL:
      return {
        loading: true,
        error: action.payload,
      };
    default:
      return state;
  }
};
